module.exports = __webpack_public_path__ + "img/regular_voltage_fault.291a3fd0.svg";